<code-input
  #codeInput
  [codeLength]="length"
  [disabled]="isDisabled"
  [initialFocusField]="0"
  [ngClass]="{ error: canShowError() }"
  (codeChanged)="onCodeChanged()"
  (codeCompleted)="onCodeCompleted($event)"
/>
